var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-img"},[_c('van-image',{attrs:{"lazy-load":"","src":_vm.$route.query.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }